<template>
  <div class="flex items-start gap-2 p-2">
    <div class="shrink-0">
      <div
        :class="[isDragging ? 'cursor-grabbing' : 'cursor-grab']"
        :draggable="true"
        :style="{ opacity: 0.99999 }"
        @dragstart="handleDragStart"
        @dragend="handleDragEnd"
      >
        <UserAvatar :user-id="assignablePerson.user.id" />
      </div>
    </div>
    <div class="flex flex-1 flex-col gap-1">
      <div class="flex items-end justify-between gap-1">
        <div class="text-base font-semibold">
          {{ assignablePerson.user.full_name }}
        </div>
        <BaseButton
          v-if="$can('manage_content')"
          icon="calendar-minus"
          size="extra-small"
          @click="isUnavailabilityModalOpen = true"
        />
      </div>

      <ul class="flex flex-col gap-1">
        <template v-if="!!assignablePerson.events.length">
          <li
            v-for="event in assignablePerson.events"
            :key="event.id"
            class="flex flex-row items-center gap-1 rounded border"
            :data-tint="
              assignmentStatuses.find(
                (assignmentStatus) =>
                  assignmentStatus.id === event.assignement_status
              )?.bg_color
            "
          >
            <span
              class="flex items-center border-slate-400 bg-primary-300 px-1 py-0.5 text-xs font-bold"
            >
              {{ $h.momentLocalised(event.date_from, 'HH:mm') }}
              {{ $h.momentLocalised(event.date_to, 'HH:mm') }}
            </span>
            <span class="flex-1 px-1 text-xs font-bold">
              {{ event.title }}
            </span>
          </li>
        </template>

        <template v-if="withAvailability && availabilityItems.length > 0">
          <AvailabilityItem
            v-for="(availabilityItem, key) in availabilityItems"
            :key="key"
            :item="availabilityItem"
          />
        </template>
      </ul>
    </div>
  </div>
  <UnavailabilityModal
    v-model:is-open="isUnavailabilityModalOpen"
    :model-id="assignablePerson.user.id"
    target="user"
    :title="assignablePerson.user.full_name"
  />
</template>

<script>
import UserAvatar from '@c/Avatar/UserAvatar.vue'
import AvailabilityItem from '@c/Dashboard/Content/Planning/components/AvailabilityItem.vue'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import UnavailabilityModal from '@c/Dashboard/Content/Planning/components/UnavailabilityModal.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AssignablePerson',
  components: {
    AvailabilityItem,
    UserAvatar,
    BaseButton,
    UnavailabilityModal
  },
  props: {
    allAvailabilityItems: {
      type: Array,
      required: false,
      default: () => []
    },
    assignablePerson: {
      type: Object,
      required: true
    },
    withAvailability: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['fetch-events'],
  data() {
    return {
      isDragging: false,
      isUnavailabilityModalOpen: false
    }
  },
  computed: {
    ...mapGetters({
      assignmentStatuses: 'metadata/getAssignmentStatusMetadata'
    }),
    availabilityItems() {
      if (!this.withAvailability) {
        return []
      }

      return this.allAvailabilityItems.filter(
        (item) => item.model_id === this.assignablePerson.user.id
      )
    }
  },
  watch: {
    isUnavailabilityModalOpen(newVal, oldVal) {
      if (newVal !== oldVal && !newVal) {
        this.$emit('fetch-events')
      }
    }
  },
  methods: {
    ...mapActions({
      processSetDataTransferObjectAction: 'planning/setDataTransferObject'
    }),
    handleDragStart() {
      this.isDragging = true
      this.processSetDataTransferObjectAction({
        type: 'user',
        model: this.assignablePerson.user,
        availabilityItems: this.availabilityItems
      })
    },
    handleDragEnd() {
      this.isDragging = false
      this.processSetDataTransferObjectAction({})
    },
    assignmentColor(assignement_status) {
      switch (assignement_status) {
        case 'pending':
          return 'bg-yellow-500'
        case 'confirmed':
          return 'bg-green-500'
        case 'refused':
          return 'bg-red-500'
        default:
          return 'bg-slate-400'
      }
    }
  }
}
</script>
